import { render, staticRenderFns } from "./TitleHeaderTable.vue?vue&type=template&id=b1e7841c&scoped=true&"
var script = {}
import style0 from "./TitleHeaderTable.vue?vue&type=style&index=0&id=b1e7841c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e7841c",
  null
  
)

export default component.exports